export const INTERVAL_OPTIONS = [
  // { key: '1', value: '1', text: '1 month' },
  // { key: '3', value: '3', text: '3 months' },
  { key: '6', value: '6', text: '6 months' },
  { key: '12', value: '12', text: '12 months' },
  { key: '24', value: '24', text: '24 months' },
  { key: 'all', value: 'all', text: 'All time' },
];
